import React from "react";
import CustomTextField, { ICustomTextFieldProps } from "./CustomTextField";

type Props = Omit<ICustomTextFieldProps, "onChange"> & {
  value?: string;
  onChange?: (value: string) => void;
};

const toInputDate = (val?: string) => {
  if (!val) return "";
  if (/^\d{4}-\d{2}-\d{2}$/.test(val)) return val;
  if (val.includes("T")) {
    return val.split("T")[0];
  }
  const d = new Date(val);
  if (isNaN(d.getTime())) return "";
  const year = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${year}-${m}-${day}`;
};

const toIsoDate = (val: string) => {
  if (!val) return "";
  return val;
};

const CustomDateField: React.FC<Props> = ({ value, onChange, ...rest }) => {
  const inputVal = toInputDate(value);

  return (
    <CustomTextField
      {...rest}
      type="date"
      value={inputVal}
      onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
        const v = e.target.value;
        const iso = toIsoDate(v);
        onChange?.(iso);
      }}
    />
  );
};

export default CustomDateField;
